import { Outlet, useLocation } from "react-router-dom";
import { Suspense } from "react";
import { AnimatePresence } from "framer-motion";
import { SettingsNavigation as SettingsSideNav } from "./navigation";
import { useBootstrapAppData } from "./hooks/useBootstrapAppData";
import RouteFallback from "../_components/loaders/RouteFallback";
import "./SettingsLayout.scss";

const SettingsLayout = () => {
  const displayZone = useBootstrapAppData();
  const location = useLocation();

  return (
    <div className="settings-layout">
      <SettingsSideNav />
      <div className="settings-layout__main">
        <AnimatePresence>
          <Suspense fallback={<RouteFallback />}>
            <Outlet key={`${location.pathname}|${displayZone || ""}`} />
          </Suspense>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default SettingsLayout;
